export class SurveyTaskCompleterModel {
    constructor(completer) {
        Object.assign(this, completer);
    }
    get referralCode() {
        return this.shareableReferralCode.toUpperCase();
    }
}
